<template>
  <div class="container">
      <div class="small_left">
        <part1 />
      </div>
      <div class="small_right">
        <part2 />
      </div>
  </div>
</template>

<script>


import { dataInterface } from '@/api/dataInterfaceApi';
import part1 from './part1.vue'
import part2 from './part2.vue'
export default {
  data () {
    return {
    };
  },
  components: {
    part1,
    part2
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    
  },
  mounted () {
    
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .small_left{
    display: flex;
    flex-direction:column;
  }
  .small_right{
    display: flex;
    flex-direction:column;
  }
}
</style>